import { render } from "./ReportView.vue?vue&type=template&id=524b852c&scoped=true"
import script from "./ReportView.vue?vue&type=script&lang=js"
export * from "./ReportView.vue?vue&type=script&lang=js"

import "./ReportView.vue?vue&type=style&index=0&id=524b852c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524b852c"]])

export default __exports__